module.exports = __webpack_public_path__ + "img/4.c022d382.png";